import { inject, Injectable } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs';

import { TellentHttpApiService } from '@core/tellent-http-legacy';
import type { SkillsImport, SkillsImportCreateParams } from '@core/tellent-skills-types';
import { ORG_GUID } from '@core/tellent-types';

@Injectable({ providedIn: 'root' })
export class SkillsImportHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly orgGuid = inject(ORG_GUID);

  public submitImport(importId: number, userPrompt: string | null): Observable<void> {
    return this.httpApi
      .patch(
        `/positions/org/${this.orgGuid}/positions/skills-imports/${importId}/submit`,
        null,
        { userPrompt },
        { skipCompany: true },
      )
      .pipe(map(() => undefined));
  }

  public getImport(id: number): Observable<SkillsImport> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/positions/skills-imports/${id}`, null, {
        skipCompany: true,
      })
      .pipe(map(response => response.data));
  }

  public createImport({ files }: SkillsImportCreateParams): Observable<SkillsImport> {
    const formData = new FormData();
    files.forEach(file => formData.append('files[]', file));

    return this.httpApi
      .post(`/positions/org/${this.orgGuid}/positions/skills-imports`, null, formData, {
        skipCompany: true,
      })
      .pipe(map(response => response.data));
  }
}
